import { USERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import usersTypes from '../../constants/usersTypes'
import { axios } from '../../services'
import store from '../../store'

import { update_current_user } from './'
// import { try_force_logoff } from '../auth'

const update_user_request = () => {
  return {
    type: usersTypes.update.request
  }
}

const update_user_success = (response) => {
  return {
    type: usersTypes.update.success,
    payload: response.data.user
  }
}

const update_user_failure = (messages) => {
  return {
    type: usersTypes.update.failure,
    payload: messages
  }
}

const update_user = (user_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_user_request())

    // Request
    axios.patch(
      formatRoute(USERS_ROUTES.update, {id: user_id}),
      values
    ).then( response => {
      // success
      const {id} = store.getState().auth.current_user.data
      if (user_id === id) {
        dispatch( update_current_user(response) )
      }
      dispatch( update_user_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating user."]
      }
      window.showSnackbar('error', errors)
      // dispatch( try_force_logoff(error.response) )
      dispatch( update_user_failure(errors))
    })
  }

}

export {
  update_user
}



// WEBPACK FOOTER //
// ./src/js/actions/users/update.js